import React from "react";
import { compose } from "redux";
import classNames from "classnames";

import {
  getLoginWithRedirectUrl,
  getRegisterWithRedirectUrl
} from "../../../../../../../lib/auth/authRedirectUrl";
import withTranslations from "../../../../../../../hocs/withTranslations";
import useIsDesktop from "../../../../hooks/useIsDesktop";
import LandingTypography from "../../../Homepage/components/LandingTypography";

import Error from "../ErrorPage/assets/error.svg";

const SignInRequiredPage = ({ title, description, translate, locale }) => {
  const isDesktop = useIsDesktop();

  const loginUrl = getLoginWithRedirectUrl({ locale });
  const registerUrl = getRegisterWithRedirectUrl({ locale });

  return (
    <LandingTypography className={"plans"}>
      <div className={"flex flex-col align-center text-center mt-14"}>
        <img
          src={Error}
          alt={translate("Error icon")}
          height={isDesktop ? 300 : 200}
          width={isDesktop ? 403 : 268}
        />
        <h1
          className={classNames(
            "mt-10 mb-4 text-2xl font-semibold text-black text-center",
            {
              "mt-10 text-2xl": isDesktop,
              "mt-6 text-xl": !isDesktop
            }
          )}
        >
          {title ?? translate("Sign in required")}
        </h1>
        <p
          className={classNames("text-black opacity-70 max-w-90", {
            "text-xs": isDesktop,
            "text-sm": !isDesktop
          })}
        >
          {description ??
            translate("You need to log in or register to continue.")}
        </p>
        <div className={"flex flex-wrap gap-4 justify-center mt-4"}>
          <a className={"button-1"} href={loginUrl}>
            {translate("Log in")}
          </a>
          <a className={"button-1"} href={registerUrl}>
            {translate("Register")}
          </a>
        </div>
      </div>
    </LandingTypography>
  );
};

export default compose(withTranslations)(SignInRequiredPage);
